/**
 * Adyen's hosted checkout: the fallback the backend picks when the page's origin is not
 * registered on the client key, so Drop-in could not mount here. The payment then runs in a popup
 * on Adyen's own page, which redirects to a Calenso return page that reports back to this window.
 */
export const ADYEN_HOSTED_CONSTANTS = {
  /** `mode` of a session answered for the hosted page. Anything else is Drop-in. */
  MODE_HOSTED: 'hosted',
  /** Sent as `checkout_mode` to force the hosted page; the backend ignores any other value. */
  CHECKOUT_MODE_HOSTED: 'hosted',
  /** The `source` tag the Calenso return page puts on its postMessage. */
  MESSAGE_SOURCE: 'calenso-adyen-hosted',
  /** Named, so a second press focuses the same popup instead of opening another one. */
  POPUP_NAME: 'calenso-adyen-pay',
  POPUP_FEATURES: 'popup,width=480,height=720',
  /** How often the popup is checked for having been closed. */
  CLOSED_CHECK_INTERVAL_MS: 500,
  /**
   * How long a hosted session lives, counted from when its answer arrived. The backend mints hosted
   * sessions for 25 minutes. Its absolute `expires_at` is deliberately not compared with this
   * device's clock: a clock that is off by minutes would then kill a session Adyen still accepts.
   */
  SESSION_LIFETIME_MS: 25 * 60 * 1000,
  /** Taken off the lifetime for the time the session answer spent in transit. */
  SESSION_EXPIRY_MARGIN_MS: 30 * 1000,
  /**
   * After the popup reads as closed without a result, the stored result is still asked for at this
   * slower pace until the session expires. A popup can read as closed while the shopper is still
   * paying in it (a page in it cut the link to this window), and a late result must still settle.
   */
  LATE_RESULT_POLL_INTERVAL_MS: 5000,
  /** The `status` of `GET adyen/hosted-result` that carries a result. */
  RESULT_STATUS: {
    RETURNED: 'returned',
  },
} as const;
